<template>
    <div>
        <v-dialog fullscreen v-model="showPreviewDialog" hide-overlay
                  transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dense dark color="primary">
                    <v-btn icon dark @click="showPreviewDialog=false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span style="margin-left: 30px;">{{title}}</span>
                </v-toolbar>
                <v-container class="ma-0 pa-0" style="padding: 0px;margin: 0px;">
                    <div class="ma-0 pa-0"
                         style="max-height: 720px;overflow:auto;background-color: #e0e0e0;">
                        <div class="page"
                             style="padding-bottom:25mm;padding-top:35mm;position:relative;width: 210mm;min-height: 225mm;background: white;box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);margin: 5mm auto;">
                            <div v-html="docHtml"
                                 style="min-height: 225mm;font-family: 仿宋_GB2312;font-size: 16pt;position: relative;margin-left: 26mm;margin-right: 24mm;">

                            </div>
                        </div>
                    </div>
                </v-container>
            </v-card>
        </v-dialog>
        <v-layout class="v-form-header mt-1">
            <v-btn @click="goBack" color="rgba(0,0,0,.7)" small text tile>
                <v-icon color="gray">mdi-step-backward</v-icon>
                返回
            </v-btn>
            <v-btn :loading="$store.getters.loading['DOC_CONTENT_HTML_UPDATE']" @click="onSave" color="rgba(0,0,0,.7)"
                   small
                   text
                   tile>
                <v-icon color="gray">mdi-content-save</v-icon>
                保存
            </v-btn>

            <v-btn :loading="$store.getters.loading['CONTENT_PREVIEW']" @click="onPreview()"
                   color="rgba(0,0,0,.7)" small
                   text
                   tile>
                <v-icon color="gray">mdi-eye</v-icon>
                预览
            </v-btn>
            <span style="margin-left: 130px;margin-top:5px;">{{title}}</span>
        </v-layout>
        <v-container class="pa-0 ma-0" style="margin-top:2px !important;">
            <v-row align="center"
                   justify="center">
                <v-col class="d-flex justify-center">
                    <ContentEditor v-if="contentHtml!=null" class="justify-center align-center" style="width: 225mm"
                                   ref="editor"
                                   v-model="contentHtml"></ContentEditor>
                </v-col>
            </v-row>
        </v-container>

    </div>
</template>
<script>
    import ContentEditor from "./ContentEditor";

    export default {
        components: {ContentEditor},
        docId: null,
        data() {
            return {
                showPreviewDialog: false,
                docHtml: '',
                contentHtml: null,
                title: null
            }
        },
        created() {
            this.docId = this.$route.query.id;
            this.$request
                .request("DOC_CONTENT_HTML", {docId: this.docId})
                .then(response => {
                    this.contentHtml = response.data.contentHtml;
                    this.title = response.data.title;
                });
        },
        methods: {
            onSave() {
                let body = {
                    id: this.docId,
                    contentHtml: this.$refs.editor.getContent()
                }
                this.$request
                    .request("DOC_CONTENT_HTML_UPDATE", body)
                    .then(response => {
                        this.$message.success("保存成功");
                    })
            },
            onPreview() {
                let item = {
                    id: this.docId,
                    contentHtml: this.$refs.editor.getContent()
                }
                this.$request
                    .request("CONTENT_PREVIEW", item)
                    .then((response) => {
                        this.docHtml = response.data.contentHtml;
                        this.showPreviewDialog = true;
                    });
            },
            goBack() {
                window.close();
            },
        }
    }
</script>